import { SALE_BEFORE_URL } from "../constants/constants";
import { getServicePhone } from "../common";

export const SIDEBAR_NAMESPACE = {
  ONLINE_CONSULT: "online-consult",
  HOT_LINE: "hot-line",
  APP: "APP",
  PRESALE_CONSULT: "presale-consult",
  SERVICE_ACCOUNT: "service-account",
  HELP_CENTER: "help-center",
  USER_CENTER: "user-center",
  DETAIL_SERVICE_ACCOUNT: "detail-service-account",

};

export const SIDEBAR_ITEMS = [
  /** 售前咨询 **/
  {
    id: SIDEBAR_NAMESPACE.PRESALE_CONSULT,
    oid: null,
    iconFontName: ``,
    name: "在线咨询",
    clickAction: "jump-link",
    link: SALE_BEFORE_URL,
    is_hover: false,
    has_bay: false,
    bay_data: null,
    bay_oid: null,
    bay_link: null,
  },

  /** 在线咨询 **/
  {
    id: SIDEBAR_NAMESPACE.ONLINE_CONSULT,
    oid: null,
    iconFontName: `icon-zixun`,
    name: "在线咨询",
    clickAction: null,
    link: "",
    is_hover: false,
    has_bay: true,
    bay_data: `
            <div class="tip" >扫码添加微信：</div>
            <img class="qrcode"  src="${require("../../assets/img/toolbar/qrcode_online_consult.png")}" alt="" />
`,
    bay_oid: null,
    bay_link: null,
  },
  /** 咨询热线 **/
  {
    id: SIDEBAR_NAMESPACE.HOT_LINE,
    oid: null,
    iconFontName: `icon-dianhuazixun`,
    name: "电话咨询",
    clickAction: null,
    link: "",
    is_hover: false,
    has_bay: true,
    bay_data: `
            <div class="tip" >咨询电话：</div>
            <div class="phone" >${getServicePhone()}</div>
            `,
    bay_oid: null,
    bay_link: null,
  },
   /** 详情服务号 **/
  {
    id: SIDEBAR_NAMESPACE.DETAIL_SERVICE_ACCOUNT,
    oid: null,
    iconFontName: `icon-weixin`,
    name: "服务号",
    clickAction: null,
    link: "",
    is_hover: false,
    has_bay: true,
    bay_data: `<div class="tip" >关注公众号：</div><img class="qrcode"  src="${require("../../assets/img/toolbar/qrcode_wx.png")}" alt="" />`,
    bay_oid: null,
    bay_link: null,
  },
  /** 公众号 **/
  {
    id: SIDEBAR_NAMESPACE.SERVICE_ACCOUNT,
    oid: null,
    iconFontName: `icon-weixin`,
    name: "公众号",
    clickAction: null,
    link: "",
    is_hover: false,
    has_bay: true,
    bay_data: `<div class="tip" >关注公众号：</div><img class="qrcode"  src="${require("../../assets/img/toolbar/qrcode_wx.png")}" alt="" />`,
    bay_oid: null,
    bay_link: null,
  },
  /** 会员中心 **/
  {
    id: SIDEBAR_NAMESPACE.USER_CENTER,
    oid: null,
    iconFontName: `icon-user-center`,
    name: "会员中心",
    clickAction: "popup",
    link: "",
    is_hover: false,
    has_bay: false,
    bay_data: null,
    bay_oid: null,
    bay_link: null,
  },
];
